import { Variants } from "motion/react";


export const navlist: Variants = {
    initial: {
      transition: { staggerChildren: 0.2, delayChildren: 0.3 }
    },
    animate: {
      transition: { staggerChildren: 0.2, delayChildren: 0.3 }
    },
    exit: {
      transition: { staggerChildren: 0.2, staggerDirection: -1 }
    }
  };
  
  export const navitem: Variants = {
    initial: {
      y: 40,
      opacity: 0,
      transition: {
        ease: "easeInOut"
      }
    },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        ease: "easeInOut"
      }
    },
    exit: {
      y: 40,
      opacity: 0,
      transition: {
        ease: "easeInOut"
      }
    }
  };